import { render, staticRenderFns } from "./mould_equipment_insert.vue?vue&type=template&id=afecff18&"
import script from "./mould_equipment_insert.vue?vue&type=script&lang=js&"
export * from "./mould_equipment_insert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports